import Header from "@/components/Header";
import ServicesSection from "@/components/ServicesSection";
import ProcessSection from "@/components/ProcessSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import SEOHead from "@/components/SEOHead";

const ServicesPage = () => {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="خدمات الديكور والتشطيبات بالرياض | حسن عبدالله"
        description="خدمات ديكورات وتشطيبات متكاملة بالرياض — جبس بورد، دهانات، ورق جدران، بديل رخام، باركيه، ترميم ومقاولات عامة بأعلى جودة وأفضل الأسعار."
        canonical="/services"
        schema={{
          "@context": "https://schema.org",
          "@type": "Service",
          "serviceType": "Decoration and Contracting",
          "provider": {
            "@type": "LocalBusiness",
            "name": "حسن عبدالله للمقاولات والديكورات"
          },
          "areaServed": { "@type": "City", "name": "الرياض" },
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "خدمات الديكور والتشطيبات",
            "itemListElement": [
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "أعمال الجبس بورد" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "دهانات وورق جدران" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "بديل الرخام" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "ترميم ومقاولات عامة" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "تركيب باركيه" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "تركيب مرايات ديكور" } }
            ]
          }
        }}
      />
      <Header />
      <div className="pt-20">
        <ServicesSection />
        <ProcessSection />
      </div>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default ServicesPage;
